<section
  class="ui-stat"
  [class.ui-stat-neutral]="isNeutral()"
  [class.ui-stat-info]="isInfo()"
  [class.ui-stat-success]="isSuccess()"
  [class.ui-stat-warning]="isWarning()"
  [class.ui-stat-danger]="isDanger()"
>
  <span class="ui-stat-value">{{ value() }}</span>
  <span class="ui-stat-label">{{ label() }}</span>
  @if (hasDescription()) {
    <span class="ui-stat-description">{{ description() }}</span>
  }
</section>
